/*
  Fotos de las resenas de Google en calidad buena.

  El app pide siempre la miniatura (la URL termina en "=k-no", que devuelve
  unos 384 px de ancho). Para el mosaico de la tarjeta alcanza, pero cuando se
  abre la foto a pantalla completa esa misma imagen se estira y se ve borrosa,
  sobre todo en el celular.

  El CDN de Google acepta otro sufijo de tamano en la misma URL, asi que al
  abrir el visor se cambia "=k-no" por "=w1600". Medido sobre una foto real:
  =k-no da 384x512, =w1600 da 1600x2133 y =s0 el original de 3024x4032.
  Se usa 1600 y no el original para no bajar varios MB por foto.

  Las miniaturas no se tocan: ya vienen a 384 px y se muestran a 120, o sea
  que estan bien y son livianas.

  Ademas se recorta el mosaico a 2 fotos por resena. El app dibuja TODAS las
  fotos y tapa las que sobran con la clase "hide", y al ultimo visible le pone
  photo-left="N" + shadow, que su CSS convierte en el cartelito "+N". Aca se
  hace lo mismo pero cortando en 2, para que las tarjetas no queden tan altas.
  Las fotos ocultas siguen en el HTML, asi que el visor las sigue mostrando
  todas.
*/
(function () {
  'use strict';

  var GRANDE = '=w1600';
  var VISOR = '.swiper-zoom-container img';

  function esFotoDeGoogle(src) {
    return typeof src === 'string' && src.indexOf('googleusercontent.com') !== -1;
  }

  function agrandar(img) {
    if (!img || !esFotoDeGoogle(img.src)) return;
    if (img.src.indexOf(GRANDE) !== -1) return;          // ya esta cambiada
    var nuevo = img.src.replace(/=[^=\/?]*$/, GRANDE);
    if (nuevo !== img.src) img.src = nuevo;
  }

  var MAX_VISIBLES = 2;
  var MOSAICO = '.agrs__card-photos';
  var DENTRO = '.agrs__card-photos-item-wrapper-position-inside';

  function ajustarMosaico(cont) {
    var items = [].slice.call(cont.children);
    if (!items.length) return;

    var sobran = items.length - MAX_VISIBLES;

    // No se toca la clase "hide" del app: no es la que esconde. El app oculta
    // desde la 5a en adelante con nth-child, asi que "hide" sola no hace nada.
    // Se usa una clase propia, con su regla en sf-fonts.liquid.
    for (var i = 0; i < items.length; i++) {
      if (i < MAX_VISIBLES) items[i].classList.remove('sf-foto-oculta');
      else items[i].classList.add('sf-foto-oculta');

      var dentro = items[i].querySelector(DENTRO);
      if (dentro) {
        dentro.removeAttribute('photo-left');
        dentro.removeAttribute('shadow');
      }
    }

    if (sobran > 0) {
      var ultimo = items[MAX_VISIBLES - 1].querySelector(DENTRO);
      if (ultimo) {
        ultimo.setAttribute('photo-left', String(sobran));
        ultimo.setAttribute('shadow', '');
      }
    }
  }

  function barrer(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;

    if (raiz.matches && raiz.matches(VISOR)) agrandar(raiz);
    var encontradas = raiz.querySelectorAll(VISOR);
    for (var i = 0; i < encontradas.length; i++) agrandar(encontradas[i]);

    if (raiz.matches && raiz.matches(MOSAICO)) ajustarMosaico(raiz);
    var mosaicos = raiz.querySelectorAll(MOSAICO);
    for (var j = 0; j < mosaicos.length; j++) ajustarMosaico(mosaicos[j]);
  }

  function arrancar() {
    barrer(document);

    var obs = new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var c = cambios[i];
        if (c.type === 'attributes') {
          agrandar(c.target);
          continue;
        }
        for (var j = 0; j < c.addedNodes.length; j++) {
          if (c.addedNodes[j].nodeType === 1) barrer(c.addedNodes[j]);
        }
      }
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
